import { render, staticRenderFns } from "./communityManage.vue?vue&type=template&id=54db9fc8&scoped=true"
import script from "./communityManage.vue?vue&type=script&lang=js"
export * from "./communityManage.vue?vue&type=script&lang=js"
import style0 from "./communityManage.vue?vue&type=style&index=0&id=54db9fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54db9fc8",
  null
  
)

export default component.exports